import { render, staticRenderFns } from "./call.vue?vue&type=template&id=e99a7f60&scoped=true&"
import script from "./call.vue?vue&type=script&lang=js&"
export * from "./call.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e99a7f60",
  null
  
)

export default component.exports